import { api } from '@/api'
import type { ChangePasswordInput, UserSettings } from '../types'

// GET /bff/settings → { language, timeZone }.
export function getSettings(): Promise<UserSettings> {
  return api.get<UserSettings>('/settings')
}

// POST /bff/settings → the stored { language, timeZone }.
export function setSettings(input: UserSettings): Promise<UserSettings> {
  return api.post<UserSettings>('/settings', { body: input })
}

// PUT /bff/password → 204 No Content.
export function changePassword(input: ChangePasswordInput): Promise<void> {
  return api.put<void>('/password', { body: input })
}
